import React from 'react';
import SvgIcon from './svgIcon';

const SvgSupport = props => {
  return (
    <SvgIcon width={24} height={24} {...props}>
      <path
        fill="currentColor"
        d="M12,4 C7.6,4 4,7.6 4,12 C4,16.4 7.6,20 12,20 C16.4,20 20,16.4 20,12 C20,7.6 16.4,4 12,4 Z M12,17 C11.4,17 11,16.6 11,16 C11,15.4 11.4,15 12,15 C12.6,15 13,15.4 13,16 C13,16.6 12.6,17 12,17 Z M13.5,12.4 C13,12.7 13,12.8 13,13 L13,14 L11,14 L11,13 C11,11.7 11.8,11.1 12.4,10.7 C12.9,10.4 13,10.3 13,10 C13,9.4 12.6,9 12,9 C11.6,9 11.3,9.2 11.1,9.5 L10.6,10.4 L8.9,9.4 L9.4,8.5 C9.9,7.6 10.9,7 12,7 C13.7,7 15,8.3 15,10 C15,11.4 14.1,12 13.5,12.4 Z"
      />
    </SvgIcon>
  );
};

export default SvgSupport;
